module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('calendar.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('calendar-header'), _vm._v(" "), _c('calendar-body'), _vm._v(" "), _c('div', {
    staticClass: "small text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.timezone', {
        timezone: _vm.timezone
      }))
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d73c9fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue
// module id = 552
// module chunks = 0